import styles from './GradientText.module.scss';
import React, { ReactNode } from 'react';
import clsx from 'clsx';

// @props children: ReactNode;
// @props className?: string;
// @props colors?: string[];
// @props animationSpeed?: number;
// @props showBorder?: boolean;
// @props as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

type ElementType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

interface GradientTextProps {
  children: ReactNode;
  className?: string;
  colors?: string[];
  animationSpeed?: number;
  showBorder?: boolean;
  as?: ElementType;
}

export default function GradientText({
  children,
  className = '',
  colors = ['#060606', '#602D11', '#C04810', '#D65619', '#E75D1C', '#FE8B47'],
  animationSpeed = 8,
  showBorder = false,
  as: Element = 'p',
}: GradientTextProps) {
  const gradientStyle = {
    backgroundImage: `linear-gradient(160deg, ${colors.join(', ')})`,
    animationDuration: `${animationSpeed}s`,
  };

  return (
    <div className={clsx(styles.animatedGradientText, className)}>
      {showBorder && (
        <div className={styles.gradientOverlay} style={gradientStyle}></div>
      )}
      {React.createElement(
        Element,
        { className: styles.textContent, style: gradientStyle },
        children
      )}
    </div>
  );
}
